var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Programación de Informe" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("ProgramacionInformeForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              informeProgramadoSeleccionado: _vm.informeProgramadoSeleccionado,
              accion: 3
            }
          }),
          _c("ConfigurarNotificacion", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.configurarNotificacion.step,
                expression:
                  "pasoActivoIndex === pasos.configurarNotificacion.step"
              }
            ],
            attrs: {
              distribucionSeleccionada: _vm.distribucion,
              calendarioSeleccionado: _vm.notificacion
                ? _vm.notificacion.calendarios
                : [],
              informeProgramadoSeleccionado: _vm.informeProgramadoSeleccionado,
              disabled: true
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }